import { Repository } from "src/firebase/firestore/repository";
import { Post } from "../types/post.type";

class PostRepository extends Repository<Post> {
  constructor() {
    super("posts");
  }
}

export const postRepository = new PostRepository();
